
export default {
  props: {
    // 接受父组件传递的值，用来控制图形验证的加载
    isGeet: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 310
    },
    product: {
      type: String,
      default: 'popup'
    }
  },
  watch: {
    // 监听参数的变化，调用极验
    isGeet(newV) {
      if (!newV) return false
      this.$nextTick(() => {
        this.gtCaptcha()
        this.$refs.btn.click() // 这里通过按钮事件调用极验
      })
    }
  },
  methods: {
    updateIsGeet() {
      this.gtCaptcha()
    },
    async gtCaptcha() {
      const { succeed = false, result = {} } = await this.$api.home.userPhone({
        clienttype: 'web'
      })
      if (succeed) this.initvify(result)
    },
    initvify(data = {}) {
      const lang = this.$store.state.LanguageCode
      const { gt = '', challenge = '', success = true } = data
      this.$initGeet(
        {
          gt,
          challenge,
          offline: !success,
          new_captcha: data.new_captcha,
          lang,
          product: this.product,
          width: `${this.width}px`,
          api_server: 'api.geetest.com'
        },
        (captchaObj) => {
          this.geetest = captchaObj
          captchaObj.appendTo('#huakuai')
          captchaObj
            .onReady(() => {
              // 验证码ready之后才能调用verify方法显示验证码(可以显示窗口了)
              if (this.product == 'bind') captchaObj.verify() // 显示验证码窗口
            })
            .onSuccess(() => {
              this.$emit('geetPath', captchaObj.getValidate())
            })
            .onError(() => {
              this.$emit('geetError')
              console.log('极验错误')
            })
        }
      )
    }
  }
}
